import React from "react";
// import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import StatusBadge from "./StatusBadge";
import ClickTooltip from "./ClickTooltip";
import { formatDateString, formatTs, formatValue, pick } from "./format";
import { getFieldValue, getRefId } from "./compare";

// stages of one record, with a checkbox per row
//   picked: stageNum[]  |  a stage is selectable when it has data
export default function StagesTable({
  stages,
  recordId,
  category,
  picked,
  onTogglePick,
  onToggleAll,
  onViewData,
}) {
  const selectable = stages.filter((s) => s.found && s.data);
  const allPicked = selectable.length > 0 && picked.length === selectable.length;
  const showMd5 = category === "refid";

  return (
    <div className="table-responsive bg-body border rounded-3">
      <table className="table table-bordered table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: 40 }}>
              <input
                type="checkbox"
                className="form-check-input"
                aria-label="Select all stages with data"
                checked={allPicked}
                disabled={selectable.length === 0}
                onChange={onToggleAll}
              />
            </th>
            {/* <th style={{ width: 60 }}>Stage</th> */}
            <th className="width-9p">Table</th>
            <th>Text</th>
            <th>Target</th>
            <th className="width-22p">{showMd5 ? "Clean MD5" : "Ref ID"}</th>
            <th className="width-5p">Type</th>
            <th className="width-6p">Multipart</th>
            <th className="width-4p">Part</th>
            <th className="width-13p">Status</th>
            {/* <th>Created At</th> */}
          </tr>
        </thead>
        <tbody>
          {stages.map((stage) => {
            const canPick = stage.found && !!stage.data;
            return (
              <tr key={`${recordId}-${stage.stageNum}`}>
                <td>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    aria-label={`Select ${stage.stageLabel}`}
                    disabled={!canPick}
                    checked={picked.includes(stage.stageNum)}
                    onChange={() => onTogglePick(stage.stageNum)}
                  />
                </td>
                {/* <td>{stage.stageNum || "-"}</td> */}
                <td>
                  {/* click -> tooltip with the search label (database) */}
                  <ClickTooltip label={stage.stageSearch}>
                    {stage.stageLabel || "-"}
                  </ClickTooltip>
                </td>
                <td>{formatValue(getFieldValue(stage, "cleantxt"))}</td>
                <td>{pick(stage, "tgttxt") || "-"}</td>
                <td className="text-break">
                  {canPick ? (
                    // click -> popup with ALL fields and values of this table row
                    <strong
                      onClick={() => onViewData(stage, true)}
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                    >
                      {formatValue(showMd5 ? getFieldValue(stage, "cleanmd5") : getRefId(stage))}
                    </strong>
                  ) : (
                    <span className="text-secondary">-</span>
                  )}
                </td>
                <td>{pick(stage, "type")}</td>
                <td>{pick(stage, "multipart")}</td>
                <td>{pick(stage, "part")}</td>
                {/* <td>
                  {canPick ? (
                    <button
                      type="button"
                      className="btn btn-md btn-outline-primary rounded-pill"
                      onClick={() => onViewData(stage)}
                    >
                      <FaArrowUpRightFromSquare className="me-1" /> View Data
                    </button>
                  ) : (
                    <span className="text-secondary">-</span>
                  )}
                </td> */}
                <td className="text">
                  <StatusBadge found={stage.found} />
                </td>
                {/* <td>{formatDateString(stage.data?.createdat ?? stage.timestamp)}</td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
